export default __webpack_public_path__ + "media/images/temporary/work-hero-5bfb4078c6b1a487002e78f7292090e5.jpg";